import React, { Component } from "react";
import PropTypes from "prop-types";
import { StyledContentDetails } from "../styled/styles";
import { connect } from "react-redux";
import axios from "axios";
import {
  deleteUserAssets,
  resetPage,
} from "../../_actions/sidebarSliderActions";
import { TldrConfirmationModal } from "./statelessView";
import {
  FaTrash,
  FaEllipsisV,
  FaArrowAltCircleDown,
  FaArrowAltCircleUp,
} from "react-icons/fa";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  Icon,
} from "@chakra-ui/react";
import { TldrNewFolderDialog } from "../styled/home/statelessView";
import TldrMoveToFolderModal from "../home/TldrMoveToFolderModal";
import { withTranslation } from "react-i18next";
import {
  createNewFolder,
  moveToFolder,
  removeFolderContent,
} from "../../_actions/folderActions";

class ImageItemActions extends Component {
  signal = axios.CancelToken.source();

  constructor(props) {
    super(props);
    this.state = {
      showDeletePopup: false,
      inProgress: false,
      showMoveToFolderModal: false,
      showNewFolderModal: false,
      showRemoveFromFolderModal: false,
    };
  }

  delete = () => {
    this.props.delete(this.props, this.signal.token).then(() => {
      if (this.props.onActionComplete) {
        this.props.onActionComplete();
      }
    });
  };

  toggleDeletePopup = () => {
    this.setState({ showDeletePopup: !this.state.showDeletePopup });
  };

  componentWillUnmount() {
    this.signal.cancel("The user aborted a request.");
  }

  handleMoveToFolder = (id, name) => {
    const { id: imageItemId } = this.props;
    const payload = {
      content_ids: [imageItemId],
    };

    this.props
      .moveToFolder(payload, id, name, this.signal.token)
      .then((res) => {
        this.setState(
          {
            showMoveToFolderModal: false,
            inProgress: false,
          },
          () => {
            if (this.props.onActionComplete) {
              this.props.resetPage("");
              this.props.onActionComplete();
            }
          }
        );
      })
      .catch((error) => {
        this.setState({
          showMoveToFolderModal: false,
          inProgress: false,
        });
      });
  };

  handleCreateNewFolder = (name) => {
    this.props
      .createNewFolder(name, this.signal.token, this.props)
      .then((folder) => {
        this.setState(
          {
            showNewFolderModal: false,
            inProgress: false,
          },
          () => {
            this.handleMoveToFolder(folder.id, folder.name);
          }
        );
      })
      .catch(() => {
        this.setState({
          showNewFolderModal: false,
          inProgress: false,
        });
      });
  };

  handleRemoveFromFolder = () => {
    const { id: imageItemId, currentFolderId } = this.props;
    const payload = {
      remove_content_ids: [imageItemId],
    };

    this.props.resetPage("");

    this.props
      .removeFolderContent(currentFolderId, payload, this.signal.token)
      .then((res) => {
        this.setState(
          {
            showRemoveFromFolderModal: false,
            inProgress: false,
          },
          () => {
            if (this.props.onActionComplete) {
              this.props.onActionComplete();
            }
          }
        );
      })
      .catch(() => {
        this.setState({
          showRemoveFromFolderModal: false,
          inProgress: false,
        });
      });
  };

  render() {
    const {
      showDeletePopup,
      inProgress,
      showMoveToFolderModal,
      showNewFolderModal,
      showRemoveFromFolderModal,
    } = this.state;
    const {
      isDragging,
      modalFor,
      showRemoveFromFolder,
      currentFolderId,
      showExtraOptions,
      t,
    } = this.props;

    return (
      <StyledContentDetails>
        <div onClick={(e) => e.stopPropagation()}>
          <Menu isLazy>
            <MenuButton
              as={IconButton}
              icon={<Icon as={FaEllipsisV} />}
              minW="0"
              h="0"
              display="flex"
              sx={{
                ":focus": {
                  boxShadow: "none",
                },
              }}
            />
            <MenuList>
              {showExtraOptions && (
                <MenuItem
                  icon={<FaArrowAltCircleUp />}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.setState({
                      showMoveToFolderModal: true,
                    });
                  }}
                >
                  {t("move_to_folder.action")}
                </MenuItem>
              )}
              {showExtraOptions && showRemoveFromFolder && (
                <MenuItem
                  icon={<FaArrowAltCircleDown />}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.setState({
                      showRemoveFromFolderModal: true,
                    });
                  }}
                >
                  {t("move_back.action")}
                </MenuItem>
              )}
              <MenuItem
                icon={<FaTrash />}
                onClick={(e) => {
                  e.stopPropagation();
                  this.toggleDeletePopup();
                }}
              >
                {t("delete", { ns: "common" })}
              </MenuItem>
            </MenuList>
          </Menu>
        </div>

        <div onClick={(e) => e.stopPropagation()}>
          <TldrConfirmationModal
            modalFor={modalFor}
            inProgress={inProgress}
            show={showDeletePopup}
            onHide={(e) => {
              this.setState({
                ...this.state,
                showDeletePopup: false,
              });
            }}
            onYes={() => {
              this.setState(
                {
                  inProgress: true,
                },
                this.delete
              );
            }}
          />
        </div>

        {showMoveToFolderModal ? (
          <div onClick={(e) => e.stopPropagation()}>
            <TldrMoveToFolderModal
              inProgress={inProgress}
              show={showMoveToFolderModal}
              onHide={() => {
                this.setState({
                  showMoveToFolderModal: false,
                });
              }}
              onYes={(folderId, folderName) => {
                this.setState(
                  {
                    inProgress: true,
                  },
                  () => this.handleMoveToFolder(folderId, folderName)
                );
              }}
              onAddFolder={() => {
                this.setState({
                  showNewFolderModal: true,
                  showMoveToFolderModal: false,
                });
              }}
              currentFolderId={currentFolderId}
            />
          </div>
        ) : null}

        {showNewFolderModal ? (
          <TldrNewFolderDialog
            inProgress={inProgress}
            show={showNewFolderModal}
            onHide={() => {
              this.setState({
                showNewFolderModal: false,
              });
            }}
            onYes={(name) => {
              this.setState(
                {
                  inProgress: true,
                },
                () => this.handleCreateNewFolder(name)
              );
            }}
          />
        ) : null}

        {showRemoveFromFolderModal ? (
          <TldrConfirmationModal
            inProgress={inProgress}
            show={showRemoveFromFolderModal}
            customMessage={t("move_back.heading", { name: modalFor })}
            customBodyMessage={t("move_back.message",{name: modalFor})}
            customPrimaryActionText={t("move_back_button.text")}
            onHide={() => {
              this.setState({ showRemoveFromFolderModal: false });
            }}
            onYes={() => {
              this.setState(
                {
                  inProgress: true,
                },
                () => this.handleRemoveFromFolder()
              );
            }}
          />
        ) : null}
      </StyledContentDetails>
    );
  }
}

ImageItemActions.propTypes = {};

const mapStateToProps = (state) => ({
  delete: PropTypes.func.isRequired,
});

const mapDispatchToProps = (dispatch) => ({
  delete: (props, token) => dispatch(deleteUserAssets(props, token)),
  moveToFolder: (payload, folderId, folderName, token) =>
    dispatch(moveToFolder(payload, folderId, folderName, token)),
  createNewFolder: (name, token, props) =>
    dispatch(createNewFolder(name, token, props)),
  removeFolderContent: (folderId, payload, signalToken) =>
    dispatch(removeFolderContent(folderId, payload, signalToken)),
  resetPage: () => dispatch(resetPage()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation(["folders", "common"])(ImageItemActions));
